import { makeAutoObservable, runInAction } from 'mobx';
import { Match } from 'navigo';

import { JobsListStore } from 'stores/jobs/JobsListStore';
import { JobsFilterStore } from 'stores/jobs/JobsFilterStore';
import { LoadStatus } from 'utils/types';

export class JobsViewStore {
  jobsFilterStore: JobsFilterStore;
  loadStatus: LoadStatus = 'none';

  constructor(private readonly jobsListStore: JobsListStore) {
    this.jobsFilterStore = new JobsFilterStore([]);
    makeAutoObservable(this, {}, { autoBind: true });
  }

  activate(match: Match) {
    this.loadStatus = 'loading';
    this.jobsListStore.activate(match);
    this.getJobs();
  }

  async canActivate() {
    await this.getJobs();

    return true;
  }

  async getJobs() {
    await this.jobsListStore.ensureJobsLoaded();

    runInAction(() => {
      this.loadStatus = this.jobsListStore.jobs ? 'success' : 'error';

      this.jobsFilterStore = new JobsFilterStore(this.jobsListStore.jobs ?? []);
    });
  }
}
